import { useState } from "react";
import { intl } from "LocaleWrapper";
import { FormDialog } from "components/dialogs/Dialogs";
import ContractCreateEdit from "../../ContractCreateEdit";
import { CargoLinkedCharter } from "types/index";
import { PurchaseCharterFromQuery } from "view/charters/PurchaseCharterDetails";
import { useTheme } from "@mui/material";

const ContractCreateEditDialog = ({ open, onClose, charter, contractId, refetch, hideContractDetails, createSalesContract }: {
    open: boolean,
    onClose: () => void,
	charter: CargoLinkedCharter | PurchaseCharterFromQuery;
	contractId?: number;
	refetch: () => void;
	hideContractDetails?: boolean;
	createSalesContract?: boolean;
}) => {
	const theme = useTheme();

	const [ loading, setLoading ] = useState(false);

	const handleOnClose = () => {
		onClose();
		setLoading(false);
	};

	return (
		<FormDialog
			open={open}
			onClose={handleOnClose}
			title={intl.formatMessage({ id: "CONTRACT" })}
			form='contractCreateEditForm'
			dialogStyling={{ content: { backgroundColor: theme.palette.mode === "dark" ? "inherit" : "#EEE", padding: 0 } }}
			loading={loading}
			maxWidth="lg">
			<div style={{ padding: "16px 24px" }}>
				<ContractCreateEdit
					hideContractDetails={hideContractDetails}
					linkedCharter={charter}
					createSalesContract={createSalesContract}
					pageInDialogSettings={{
						entityId: contractId,
						onLoadingChange: (isLoading) => setLoading(isLoading),
						onSuccess: () => {
							handleOnClose();
							refetch();
						},
					}} />
			</div>
		</FormDialog>
	);
};

export default ContractCreateEditDialog;
